export function getTimeInHotel() {
    return fetch(`${process.env.REACT_APP_BOOKING_API}/booking/time`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                return data
            } else {
                throw new Error("Ошибка при загрузке модуля бронирования.")
            }
        })
}